import { getClientBillingEmail } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const getClientBillingEmailByClientId = async (clientId) => {
  if (!clientId) return;

  try {
    const gqlParams = { id: clientId };

    const response = await client.graphql({
      query: getClientBillingEmail,
      variables: gqlParams
    });

    const results = response.data.getSpkDJTClientTbl.clientBillingEmail;

    return results;
  } catch (err) {
    return ('error getClientBillingEmailByClientId: ', [err]);
  }
}

getClientBillingEmailByClientId.propTypes = {
  clientId: PropTypes.string.isRequired,
};
